








































import Vue from 'vue';
import { login, whoAmI } from '../modules/auth/auth.service';
import { UserRoles } from '../modules/auth/auth.model';

export default Vue.extend({
  data () {
    return {
      errorMsg: '',
      loginData: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    sendLogin(): any {
      login(this.loginData).then( (res) => {
        if (res.data){
          
          if (localStorage.getItem('user-role') === UserRoles.ADMIN.key){
            this.$router.push('/');
          }else{
            this.$router.push('/evenements');
          }
          location.reload();
        }else if (res.error){
          this.errorMsg = 'Erreur de connexion.'
        }
      });
    }
  },
})
